(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            'use strict';

            function renderPlaces(data, id) {
                var labels = data.labels;
                var number = new Intl.NumberFormat(document.documentElement.lang || 'ru', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
                function node(tag, className, text, attributes) {
                    var element = document.createElement(tag);
                    if (className) {
                        element.className = className;
                    }
                    if (text !== null && text !== undefined) {
                        element.textContent = text;
                    }
                    Object.keys(attributes || {}).forEach(function (key) {
                        element.setAttribute(key, attributes[key]);
                    });
                    return element;
                }
                function append(parent, tag, className, text, attributes) {
                    var child = node(tag, className, text, attributes);
                    parent.appendChild(child);
                    return child;
                }
                function icon(parent, name) {
                    append(parent, 'span', 'hotel-nearby-icon hotel-nearby-icon--' + name, null, { 'aria-hidden': 'true' });
                }
                var placesId = id + '-places';
                var hoursId = id + '-hours';
                var root = node('section', 'content-block hotel-nearby', null, {
                    id: 'hotel-nearby', 'data-nearby': '', 'aria-labelledby': id + '-title'
                });
                var heading = append(append(root, 'div', 'hotel-nearby__heading'), 'div');
                append(heading, 'h2', 'hotel-nearby__title', labels.title, { id: id + '-title' });
                append(heading, 'p', 'hotel-nearby__subtitle', labels.subtitle);
                var toolbar = append(root, 'div', 'hotel-nearby__toolbar');
                var filters = append(toolbar, 'div', 'hotel-nearby__filters', null, { role: 'group', 'aria-label': labels.categoriesLabel });
                Object.keys(labels.categories).forEach(function (category) {
                    append(filters, 'button', 'hotel-nearby__filter', labels.categories[category], {
                        type: 'button', 'data-nearby-filter': category, 'aria-pressed': String(category === 'all'), 'aria-controls': placesId
                    });
                });
                var radii = append(append(toolbar, 'div', 'hotel-nearby__radius'), 'div', 'hotel-nearby__radius-options', null, { role: 'group', 'aria-label': labels.radiusLabel });
                Object.keys(labels.radii).forEach(function (radius) {
                    append(radii, 'button', 'hotel-nearby__radius-option', labels.radii[radius], {
                        type: 'button', 'data-nearby-radius': radius, 'aria-pressed': String(radius === '2000'), 'aria-controls': placesId
                    });
                });
                var meta = append(append(root, 'div', 'hotel-nearby__meta'), 'span', null, labels.count + ' ', { 'aria-live': 'polite', 'aria-atomic': 'true' });
                append(meta, 'strong', null, data.items.length, { 'data-nearby-count': '' });
                var carousel = append(root, 'div', 'hotel-nearby__carousel');
                var navigation = append(carousel, 'div', 'hotel-nearby__navigation', null, { 'data-nearby-navigation': '', hidden: '' });
                ['prev', 'next'].forEach(function (direction) {
                    var attrs = { type: 'button', 'aria-label': direction === 'prev' ? labels.previous : labels.next, 'aria-controls': placesId };
                    attrs['data-nearby-' + direction] = '';
                    icon(append(navigation, 'button', 'hotel-nearby__arrow' + (direction === 'prev' ? ' hotel-nearby__arrow--prev' : ''), null, attrs), 'arrow');
                });
                var slider = append(carousel, 'div', 'hotel-nearby__slider', null, { 'data-nearby-slider': '' });
                var track = append(slider, 'div', 'hotel-nearby__grid', null, { 'data-nearby-track': '', id: placesId, tabindex: '0', role: 'region', 'aria-label': labels.placesLabel });
                data.items.forEach(function (place) {
                    var card = append(track, 'article', 'hotel-nearby-card', null, {
                        'data-nearby-card': '', 'data-place-id': place.id, 'data-place-name': place.name,
                        'data-distance': place.distanceMeters, 'data-category': place.category
                    });
                    var photo = append(card, 'div', 'hotel-nearby-card__photo');
                    icon(append(photo, 'div', 'hotel-nearby-card__placeholder'), 'image');
                    if (place.photoUrl !== null) {
                        append(photo, 'img', null, null, { src: place.photoUrl, alt: place.name, width: '720', height: '440', loading: 'lazy', decoding: 'async', 'data-nearby-photo': '' });
                    }
                    var distance = append(photo, 'span', 'hotel-nearby-card__distance');
                    icon(distance, 'pin');
                    distance.appendChild(document.createTextNode(' ' + (place.distanceMeters < 1000 ? labels.meters.replace('{distance}', place.distanceMeters) : labels.kilometers.replace('{distance}', number.format(place.distanceMeters / 1000)))));
                    var body = append(card, 'div', 'hotel-nearby-card__body');
                    append(append(body, 'div', 'hotel-nearby-card__info'), 'span', 'hotel-nearby-card__type', place.typeLabel);
                    append(body, 'h3', 'hotel-nearby-card__name', place.name, { title: place.name });
                    if (place.rating !== null) {
                        var rating = append(body, 'div', 'hotel-nearby-card__rating');
                        var score = append(rating, 'span', 'hotel-nearby-card__score', null, { 'aria-label': labels.rating.replace('{rating}', number.format(place.rating)) });
                        icon(score, 'star');
                        score.appendChild(document.createTextNode(' ' + number.format(place.rating)));
                        append(rating, 'span', null, place.ratingCountLabel);
                    }
                    var footer = append(body, 'div', 'hotel-nearby-card__footer');
                    if (place.weekdayDescriptions.length) {
                        var hours = append(footer, 'button', 'hotel-nearby-card__hours', null, {
                            type: 'button', 'data-nearby-hours': '', 'aria-expanded': 'false', 'aria-controls': hoursId,
                            'aria-label': labels.hoursLabel.replace('{hours}', place.hoursToday)
                        });
                        icon(hours, 'clock');
                        hours.appendChild(document.createTextNode(' ' + place.hoursToday));
                        var schedule = append(footer, 'template', null, null, { 'data-nearby-schedule': '' });
                        append(schedule.content, 'strong', 'hotel-nearby-popup__title', place.name);
                        append(schedule.content, 'span', 'hotel-nearby-popup__label', labels.hoursTitle);
                        var list = append(schedule.content, 'ul');
                        place.weekdayDescriptions.forEach(function (description) {
                            var separator = description.indexOf(': ');
                            var row = append(list, 'li', 'hotel-nearby-popup__row');
                            append(row, 'span', 'hotel-nearby-popup__day', separator === -1 ? description : description.slice(0, separator));
                            if (separator !== -1) {
                                var intervals = append(row, 'span', 'hotel-nearby-popup__intervals');
                                description.slice(separator + 2).split(', ').forEach(function (interval) {
                                    append(intervals, 'span', null, interval);
                                });
                            }
                        });
                    }
                    if (place.mapUrl !== null) {
                        append(footer, 'a', 'hotel-nearby-card__map', labels.map, { 'data-nearby-map': '', href: place.mapUrl, target: '_blank', rel: 'noopener noreferrer' });
                    }
                });
                append(root, 'div', 'hotel-nearby-popup', null, { id: hoursId, 'data-nearby-popup': '', role: 'tooltip', hidden: '' });
                append(root, 'p', 'hotel-nearby__empty', labels.empty, { 'data-nearby-empty': '', hidden: '' });
                append(root, 'button', 'hotel-nearby__more', labels.more, { type: 'button', 'data-nearby-more': '', hidden: '' });
                return root;
            }

            function initPlaces(root, report, requestRange) {
                var cards = Array.from(root.querySelectorAll('[data-nearby-card]'));
                var filters = Array.from(root.querySelectorAll('[data-nearby-filter]'));
                var track = root.querySelector('[data-nearby-track]');
                var more = root.querySelector('[data-nearby-more]');
                var previous = root.querySelector('[data-nearby-prev]');
                var next = root.querySelector('[data-nearby-next]');
                var navigation = root.querySelector('[data-nearby-navigation]');
                var popup = root.querySelector('[data-nearby-popup]');
                var desktop = window.matchMedia('(min-width: 901px)');
                var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
                var category = 'all';
                var radius = 2000;
                var swiper = null;
                var slider = root.querySelector('[data-nearby-slider]');
                var categoryTransitionTimer;
                var categoryEnterTimer;
                var radiusButtons = Array.from(root.querySelectorAll('[data-nearby-radius]'));

                function categoryProperties(value) {
                    var filter = filters.find(function (item) {
                        return item.dataset.nearbyFilter === value;
                    });
                    return { category_id: value, category_name: filter ? filter.textContent.trim() : value };
                }

                function matchesFilters(card) {
                    return (category === 'all' || card.dataset.category === category) && Number(card.dataset.distance) <= radius;
                }
                var expanded = false;
                var previewCount = 6;
                var activeHours = null;
                var hideTimer;

                function closeHours() {
                    clearTimeout(hideTimer);
                    if (activeHours) {
                        activeHours.setAttribute('aria-expanded', 'false');
                        activeHours.removeAttribute('aria-describedby');
                    }
                    activeHours = null;
                    popup.hidden = true;
                }

                function showHours(button) {
                    clearTimeout(hideTimer);
                    if (activeHours !== button) {
                        closeHours();
                        activeHours = button;

                        popup.textContent = '';
                        popup.appendChild(button.parentNode.querySelector('[data-nearby-schedule]').content.cloneNode(true));
                        button.setAttribute('aria-expanded', 'true');
                        button.setAttribute('aria-describedby', popup.id);
                    }
                    popup.hidden = false;
                    var bounds = button.getBoundingClientRect();
                    var left = Math.max(12, Math.min(bounds.left, window.innerWidth - popup.offsetWidth - 12));
                    var top = bounds.top - popup.offsetHeight - 8;
                    if (top < 12) {
                        top = Math.min(bounds.bottom + 8, window.innerHeight - popup.offsetHeight - 12);
                    }
                    popup.style.left = left + 'px';
                    popup.style.top = Math.max(12, top) + 'px';
                }

                function scheduleClose() {
                    clearTimeout(hideTimer);
                    hideTimer = setTimeout(closeHours, 140);
                }

                function updateArrows() {
                    previous.disabled = track.scrollLeft <= 1;
                    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
                }

                function render() {
                    clearTimeout(categoryTransitionTimer);
                    clearTimeout(categoryEnterTimer);
                    slider.classList.remove('hotel-nearby__slider--leaving', 'hotel-nearby__slider--entering');
                    closeHours();
                    if (swiper) {
                        swiper.destroy(true, true);swiper = null;
                    }
                    track.classList.remove('swiper-wrapper');
                    slider.classList.remove('swiper');
                    cards.forEach(function (card) {
                        track.appendChild(card);card.classList.remove('swiper-slide');
                    });
                    var nearbyCards = cards.filter(function (card) {
                        return Number(card.dataset.distance) <= radius;
                    });
                    if (category !== 'all' && !nearbyCards.some(function (card) {
                        return card.dataset.category === category;
                    })) {
                        category = 'all';
                    }
                    filters.forEach(function (filter) {
                        filter.hidden = filter.dataset.nearbyFilter !== 'all' && !nearbyCards.some(function (card) {
                            return card.dataset.category === filter.dataset.nearbyFilter;
                        });
                    });
                    var matched = cards.filter(matchesFilters);
                    cards.forEach(function (card) {
                        var index = matched.indexOf(card);
                        card.hidden = index === -1;
                    });
                    filters.forEach(function (filter) {
                        filter.setAttribute('aria-pressed', String(filter.dataset.nearbyFilter === category));
                    });
                    radiusButtons.forEach(function (button) {
                        button.setAttribute('aria-pressed', String(Number(button.dataset.nearbyRadius) === radius));
                    });
                    root.querySelector('[data-nearby-count]').textContent = matched.length;
                    root.querySelector('[data-nearby-empty]').hidden = matched.length !== 0;
                    more.hidden = true;
                    navigation.hidden = !desktop.matches;
                    track.scrollLeft = 0;
                    updateArrows();
                    if (!desktop.matches && matched.length) {
                        cards.forEach(function (card) {
                            if (card.hidden) {
                                card.remove();
                            }
                        });
                        slider.classList.add('swiper');
                        track.classList.add('swiper-wrapper');
                        matched.forEach(function (card) {
                            card.classList.add('swiper-slide');
                        });
                        var userSliding = false;
                        swiper = new Swiper(slider, {
                            slidesPerView: 1.12,
                            breakpoints: {
                                520: { slidesPerView: 1.65 },
                                640: { slidesPerView: 2.12 },
                                800: { slidesPerView: 2.5 }
                            },
                            spaceBetween: 12,
                            watchOverflow: true,
                            on: {
                                sliderFirstMove: function sliderFirstMove() {
                                    userSliding = true;
                                },
                                slideChange: function slideChange() {
                                    closeHours();
                                    if (userSliding) {
                                        userSliding = false;
                                        report('slider', { input: 'swipe', index: this.activeIndex });
                                    }
                                },
                                touchEnd: function touchEnd() {
                                    setTimeout(function () {
                                        userSliding = false;
                                    }, 0);
                                }
                            }
                        });
                    }
                }

                function renderFilterChange() {
                    clearTimeout(categoryTransitionTimer);
                    clearTimeout(categoryEnterTimer);
                    closeHours();
                    if (reducedMotion.matches) {
                        render();return;
                    }
                    filters.forEach(function (filter) {
                        filter.setAttribute('aria-pressed', String(filter.dataset.nearbyFilter === category));
                    });
                    slider.classList.remove('hotel-nearby__slider--entering');
                    slider.classList.add('hotel-nearby__slider--leaving');
                    categoryTransitionTimer = setTimeout(function () {
                        render();
                        slider.classList.add('hotel-nearby__slider--entering');
                        categoryEnterTimer = setTimeout(function () {
                            slider.classList.remove('hotel-nearby__slider--entering');
                        }, 280);
                    }, 140);
                }

                function slide(direction, input) {
                    var card = cards.filter(matchesFilters)[0];
                    if (!card) {
                        return;
                    }
                    report('slider', { direction: direction, input: input });
                    closeHours();
                    track.scrollBy({
                        left: direction * 2 * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap)),
                        behavior: reducedMotion.matches ? 'auto' : 'smooth'
                    });
                }

                previous.addEventListener('click', function () {
                    slide(-1, 'button');
                });
                next.addEventListener('click', function () {
                    slide(1, 'button');
                });
                track.addEventListener('scroll', function () {
                    closeHours();updateArrows();
                });
                track.addEventListener('keydown', function (event) {
                    if (event.target === track && desktop.matches && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
                        event.preventDefault();
                        slide(event.key === 'ArrowRight' ? 1 : -1, 'keyboard');
                    }
                });
                window.addEventListener('resize', function () {
                    closeHours();updateArrows();
                });
                window.addEventListener('scroll', closeHours, { passive: true });
                desktop.addEventListener('change', render);

                filters.forEach(function (filter) {
                    filter.addEventListener('click', function () {
                        category = filter.dataset.nearbyFilter;
                        report('category', categoryProperties(category));
                        expanded = false;
                        renderFilterChange();
                    });
                });
                var loadRadius = requestRange ? createRadiusLoader(2000, requestRange, function (data) {
                    var incoming = renderPlaces(data, root.querySelector('[data-nearby-popup]').id.replace(/-hours$/, ''));
                    var added = [];
                    incoming.querySelectorAll('[data-nearby-card]').forEach(function (card) {
                        if (!cards.some(function (existing) {
                            return existing.dataset.placeId === card.dataset.placeId;
                        })) {
                            cards.push(card);
                            added.push(card);
                        }
                    });
                    cards.sort(function (a, b) {
                        return Number(a.dataset.distance) - Number(b.dataset.distance) || a.dataset.placeId.localeCompare(b.dataset.placeId);
                    });
                    bindCards(added);
                    render();
                }, function (loadedRadius) {
                    if (radius > loadedRadius) {
                        radius = loadedRadius;
                    }
                    render();
                }, function (busy) {
                    root.setAttribute('aria-busy', String(busy));
                }) : function () {};

                radiusButtons.forEach(function (button) {
                    button.addEventListener('click', function () {
                        radius = Number(button.dataset.nearbyRadius);
                        report('radius', { radius_m: radius });
                        loadRadius(radius);
                        expanded = false;
                        renderFilterChange();
                    });
                });
                more.addEventListener('click', function () {
                    var nextCard = cards.filter(matchesFilters)[previewCount];
                    expanded = true;
                    report('show_more');
                    render();
                    nextCard.setAttribute('tabindex', '-1');
                    nextCard.focus({ preventScroll: true });
                });

                popup.addEventListener('mouseenter', function () {
                    clearTimeout(hideTimer);
                });
                popup.addEventListener('mouseleave', scheduleClose);
                document.addEventListener('click', function (event) {
                    if (activeHours && !activeHours.contains(event.target) && !popup.contains(event.target)) {
                        closeHours();
                    }
                });
                document.addEventListener('keydown', function (event) {
                    if (event.key === 'Escape') {
                        closeHours();
                    }
                });

                function reportMapClick(event) {
                    if (event.type === 'auxclick' && event.button !== 1) {
                        return;
                    }
                    var link = event.target.closest('[data-nearby-map]');
                    if (!link || !root.contains(link)) {
                        return;
                    }
                    var card = link.closest('[data-nearby-card]');
                    report('map', Object.assign(categoryProperties(card.dataset.category), {
                        place_id: card.dataset.placeId,
                        place_name: card.dataset.placeName
                    }));
                }
                root.addEventListener('click', reportMapClick);
                root.addEventListener('auxclick', reportMapClick);

                function bindCards(newCards) {
                    newCards.forEach(function (card) {
                        card.querySelectorAll('[data-nearby-hours]').forEach(function (button) {
                            button.addEventListener('mouseenter', function () {
                                showHours(button);
                            });
                            button.addEventListener('mouseleave', scheduleClose);
                            button.addEventListener('focus', function () {
                                showHours(button);
                            });
                            button.addEventListener('blur', scheduleClose);
                            button.addEventListener('click', function () {
                                report('hours', { place_id: card.dataset.placeId, place_name: card.dataset.placeName });
                                showHours(button);
                            });
                        });
                        var photo = card.querySelector('[data-nearby-photo]');
                        if (photo) {
                            photo.addEventListener('error', function () {
                                photo.remove();
                            });
                            if (photo.complete && photo.naturalWidth === 0) {
                                photo.remove();
                            }
                        }
                    });
                }
                bindCards(cards);
                render();
                return cards.length;
            }

            // Only advance the cached boundary after a successful response, including an empty one.
            function createRadiusLoader(initialRadius, request, receive, failed, busy) {
                var loadedRadius = initialRadius;
                var wantedRadius = initialRadius;
                var loading = false;
                function load(radius) {
                    wantedRadius = radius;
                    if (loading || wantedRadius <= loadedRadius) {
                        return;
                    }
                    var target = wantedRadius;
                    loading = true;
                    busy(true);
                    request(target, loadedRadius).then(function (data) {
                        receive(data);
                        loadedRadius = target;
                        loading = false;
                        busy(false);
                        load(wantedRadius);
                    }).catch(function () {
                        loading = false;
                        wantedRadius = Math.min(wantedRadius, loadedRadius);
                        busy(false);
                        failed(loadedRadius);
                    });
                }
                return load;
            }

            function initNearby() {
                document.querySelectorAll('[data-nearby]').forEach(function (root) {
                    initPlaces(root, function () {});
                });
                document.querySelectorAll('[data-nearby-preview]').forEach(function (preview) {
                    var blockId = crypto.randomUUID();
                    var provider = 'local_json';
                    var root;
                    var viewed = false;
                    var visible = false;
                    var viewTimer;
                    var observer;

                    function send(name, properties) {
                        try {
                            if (window.brxTracking && typeof window.brxTracking.sendAnalyticsEvent === 'function') {
                                window.brxTracking.sendAnalyticsEvent('hotel_nearby_' + name, Object.assign({
                                    hotel_id: Number(preview.dataset.hotelId),
                                    platform: preview.dataset.platform,
                                    provider: provider,
                                    block_instance_id: blockId,
                                    block_version: 2
                                }, properties || {}));
                            }
                        } catch (ignored) {
                            // Analytics must not interrupt loading places.
                        }
                    }

                    function recordView(source) {
                        if (viewed) {
                            return;
                        }
                        viewed = true;
                        send('view', { view_source: source });
                        clearTimeout(viewTimer);
                        if (observer) {
                            observer.disconnect();
                        }
                        document.removeEventListener('visibilitychange', scheduleView);
                    }

                    function scheduleView() {
                        clearTimeout(viewTimer);
                        if (visible && !document.hidden && !viewed) {
                            viewTimer = setTimeout(function () {
                                if (root.isConnected !== false) {
                                    recordView('visibility');
                                }
                            }, 1000);
                        }
                    }

                    function report(action, properties) {
                        // A deliberate action also proves the loaded block was seen.
                        recordView('interaction');
                        if (['category', 'radius', 'map'].indexOf(action) !== -1) {
                            send(action, properties);
                        }
                        send('interaction', Object.assign({ action: action }, properties || {}));
                    }

                    var loading = false;
                    var loadObserver = new IntersectionObserver(function (entries) {
                        if (loading || !entries.some(function (entry) {
                            return entry.isIntersecting;
                        })) {
                            return;
                        }
                        loading = true;
                        loadObserver.disconnect();
                        loadPlaces();
                    }, { rootMargin: '300px 0px' });
                    loadObserver.observe(preview);

                    function requestPlaces(radius, fromRadius, selectedProvider) {
                        var controller = new AbortController();
                        var timeout = setTimeout(function () {
                            controller.abort();
                        }, 15000);
                        var url = new URL(preview.dataset.loadUrl, window.location.href);
                        url.searchParams.set('radius', radius);
                        url.searchParams.set('fromRadius', fromRadius);
                        if (selectedProvider) {
                            url.searchParams.set('provider', selectedProvider);
                        }
                        return fetch(url.toString(), {
                            credentials: 'same-origin', signal: controller.signal,
                            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
                        }).then(function (response) {
                            if (!response.ok) {
                                var error = new Error('http');
                                error.httpStatus = response.status;
                                throw error;
                            }
                            return response.json();
                        }).finally(function () {
                            clearTimeout(timeout);
                        });
                    }

                    function loadPlaces() {
                        var started = performance.now();
                        requestPlaces(2000, 0).then(function (data) {
                            provider = data.provider || 'local_json';
                            root = renderPlaces(data, 'nearby-' + blockId);
                            preview.replaceWith(root);
                            var count = initPlaces(root, report, function (radius, fromRadius) {
                                return requestPlaces(radius, fromRadius, provider);
                            });
                            send('data_result', {
                                status: count ? 'success' : 'empty', places_count: count,
                                duration_ms: Math.round(performance.now() - started)
                            });
                            observer = new IntersectionObserver(function (entries) {
                                visible = entries[0].intersectionRatio >= 0.5;
                                scheduleView();
                            }, { threshold: [0, 0.5] });
                            observer.observe(root);
                            document.addEventListener('visibilitychange', scheduleView);
                        }).catch(function (failure) {
                            preview.remove();
                            if (root) {
                                root.remove();
                            }
                            send('data_result', {
                                status: 'error',
                                http_status: failure.httpStatus,
                                error_type: failure.name === 'AbortError' ? 'timeout' : failure.message === 'http' ? 'http' : failure.message === 'content' ? 'content' : 'network_or_render',
                                duration_ms: Math.round(performance.now() - started)
                            });
                        });
                    }
                });
            }
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initNearby);
            } else {
                initNearby();
            }
        })();
    }, {}] }, {}, [1]);